import React from 'react';
import PropTypes from 'prop-types';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '@/pages/dashboard-year/MetricLoader';
import DeltaMetric from '@/pages/dashboard-year/DeltaMetric';
import useCompletedPartnerProjectEvaluations from '@/features/dashboard-eval/hooks/useCompletedPartnerProjectEvaluations';
import usePartnerProjectEvaluations from '@/features/dashboard-eval/hooks/usePartnerProjectEvaluations';
import moment from 'moment-timezone';
import ComparisonMetric from '@/pages/dashboard-year/ComparisonMetric';

CompositePartnerProjectEvaluations.propTypes = {
  state: PropTypes.string,
  network: PropTypes.string,
  schoolStart: PropTypes.string,
  schoolEnd: PropTypes.string,
  titleOnly: PropTypes.bool,
  showTotals: PropTypes.bool
};

export default function CompositePartnerProjectEvaluations(props) {
  const { state, network, schoolStart, schoolEnd, titleOnly, showTotals = true } = props;

  const previousSchoolStart = titleOnly ? undefined : moment(schoolStart).subtract(1, 'year').toISOString();

  const totalEvaluations = usePartnerProjectEvaluations({ state, network, schoolStart: undefined, schoolEnd });
  const previousEvaluations = usePartnerProjectEvaluations({ state, network, schoolStart: previousSchoolStart, schoolEnd: schoolStart });
  const newEvaluations = usePartnerProjectEvaluations({ state, network, schoolStart, schoolEnd });

  const totalEvaluationsCompleted = useCompletedPartnerProjectEvaluations({ state, network, schoolStart: undefined, schoolEnd });
  const previousEvaluationsCompleted = useCompletedPartnerProjectEvaluations({ state, network, schoolStart: previousSchoolStart, schoolEnd: schoolStart });
  const newEvaluationsCompleted = useCompletedPartnerProjectEvaluations({ state, network, schoolStart, schoolEnd });

  if (
    totalEvaluations.state === PayloadStates.FETCHING ||
    previousEvaluations.state === PayloadStates.FETCHING ||
    newEvaluations.state === PayloadStates.FETCHING ||
    totalEvaluationsCompleted.state === PayloadStates.FETCHING ||
    previousEvaluationsCompleted.state === PayloadStates.FETCHING ||
    newEvaluationsCompleted.state === PayloadStates.FETCHING
  ) {
    return (
      <>
        {showTotals && (
          <>
            <MetricLoader
              name="Total partner project evaluations sent"
            />
            <MetricLoader
              name="Total partner project evaluations completed"
            />
          </>
        )}
        {!titleOnly && (
          <>
            <MetricLoader
              name="Partner project evaluations sent"
            />
            <MetricLoader
              name="Partner project evaluations completed"
            />
          </>
        )}
      </>
    );
  }

  return (
    <>
      {showTotals && (
        <>
          <DeltaMetric
            name="Total partner project evaluations sent"
            value={totalEvaluations.meta.totalCount}
            delta={newEvaluations.meta.totalCount}
            titleOnly={titleOnly}
          />
          <DeltaMetric
            name="Total partner project evaluations completed"
            value={totalEvaluationsCompleted.meta.totalCount}
            delta={newEvaluationsCompleted.meta.totalCount}
            titleOnly={titleOnly}
          />
        </>
      )}
      {!titleOnly && (
        <>
          <ComparisonMetric
            name="Partner project evaluations sent"
            value={newEvaluations.meta.totalCount}
            previousValue={previousEvaluations.meta.totalCount}
            titleOnly={titleOnly}
          />
          <ComparisonMetric
            name="Partner project evaluations completed"
            value={newEvaluationsCompleted.meta.totalCount}
            previousValue={previousEvaluationsCompleted.meta.totalCount}
            titleOnly={titleOnly}
          />
        </>
      )}
    </>
  );
}
